module.exports = __webpack_public_path__ + "img/icon62.412f621c.png";